import { Pipe, PipeTransform} from '@angular/core';
import { EFormService } from './e-form.service';


@Pipe({
    name: 'mergeField'
})
export class MergeFieldPipe implements PipeTransform {

    constructor(private eFormService: EFormService) {}
    transform(text: string, disableMergeField: boolean, triggerPipe: boolean): string {
        if (!disableMergeField) {
           text = this.eFormService.transformDatabaseMergeTag(text);
           text = this.eFormService.transformFormOnlyMergeTag(text);
        }
        return text;
    }
}
